import React, { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router';

import styled from '@emotion/styled';

import { Modal } from '../../components/Modal/Modal';
import WhatsNewModal from '../../components/Modal/ModalActions/WhatsNewModal/WhatsNewModal';
import { useAppSelector } from '../../redux/store';
import DashboardHeader from './header/DashboardHeader';
import MobileNav from './sideNav/MobileNav';
import Nav from './sideNav/Nav';

const DashboardLayoutOutlet = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { pathname } = useLocation();
  const [showModal, setShowModal] = React.useState(true);
  const { settingsData, isSettingsLoaded } = useAppSelector(
    (state) => state.settingsData,
  );

  useEffect(() => {
    containerRef.current?.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname]);

  return (
    <Container ref={containerRef}>
      <Nav />
      <MobileNav />
      <Section>
        <DashboardHeader />
        <MainContent>
          <Outlet />
        </MainContent>
      </Section>

      {/* wait for settings to load before deciding whether to show, so it doesn't flash on refresh */}
      {isSettingsLoaded && settingsData?.notified !== true && (
        <Modal
          showModal={showModal}
          setShowModal={setShowModal}
          className='blur'
        >
          <WhatsNewModal />
        </Modal>
      )}
    </Container>
  );
};

export default DashboardLayoutOutlet;

const Container = styled.div`
  display: flex;
  height: 100vh;
  overflow: auto;
  width: 100%;
  background-color: white;

  @media (max-width: 884px) {
    background-color: #f9f9f9;
  }
`;

const Section = styled.section`
  /* border: 1px solid red; */
  width: 100%;
  height: fit-content;
`;

const MainContent = styled.main`
  height: 100%;
  padding-bottom: 200px;
  width: 100%;
  /* border: 1px solid blue; */
`;
